import { jsx } from "panel";
import { TableEl } from "common/components/table";
import { propagateEvent } from "common/util/dom";
export function template() {
  const { rows } = this.state;
  return /* @__PURE__ */ jsx("div", { sel: ".users-table", style: { height: `100%` } }, /* @__PURE__ */ jsx(
    TableEl,
    {
      attrs: this.helpers.getTableAttrs(),
      props: {
        rows,
        columns: this.helpers.getTableColumns()
      },
      on: {
        selectionChange: this.helpers.handleTableSelectionChanged,
        rowClick: this.helpers.handleTableRowClicked,
        sortChange: this.helpers.handleTableSortChanged,
        columnMoved: this.helpers.handleColumnMoved,
        columnResize: (ev) => propagateEvent(this, ev)
      }
    }
  ));
}
